import i18n from '../i18n.js';

export function tx(key: string, options?: Record<string, unknown>): string {
  return i18n.t(key, options);
}

export function pickLocalized(zh: string | undefined, en: string | undefined): string {
  return i18n.language?.toLowerCase().startsWith('en') ? (en ?? zh ?? '') : (zh ?? en ?? '');
}
